export default __webpack_public_path__ + "static/media/домик.2e3dd615.jpg";